import { render } from "./TEIWrapper.vue?vue&type=template&id=5bf55da8&scoped=true"
import script from "./TEIWrapper.vue?vue&type=script&lang=js"
export * from "./TEIWrapper.vue?vue&type=script&lang=js"

import "./TEIWrapper.vue?vue&type=style&index=0&id=5bf55da8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf55da8"]])

export default __exports__